import { useState, useEffect } from 'react'
import { supabase } from '../services/supabase'

export function useOptions() {
  const [options, setOptions] = useState([])
  useEffect(() => {
    let on = true
    supabase.from('options').select('*').eq('actif', true).order('ordre').then(({ data, error }) => {
      if (on && !error && Array.isArray(data)) setOptions(data)
    })
    return () => { on = false }
  }, [])
  return options
}
